import React from "react";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import MembershipPlanCard from "./MembershipPlanCard";

const MembershipPlansGrid = ({
  plans,
  onSelectPlan,
  onLearnMore,
  selectedPlanId,
  trialEligible,
  pageVariants,
  itemVariants,
}) => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  if (!plans?.length) {
    return (
      <div className="text-center text-muted-foreground py-10">
        No membership plans available at the moment.
      </div>
    );
  }

  return (
    <motion.div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch py-8"
      variants={pageVariants}
      initial="hidden"
      animate="visible"
    >
      {plans.map((plan) => (
        <MembershipPlanCard
          key={plan.id}
          plan={plan}
          isMember={isAuthenticated}
          onSelectPlan={onSelectPlan}
          trialEligible={trialEligible}
          onLearnMore={onLearnMore}
          variants={itemVariants}
          selectedPlanId={selectedPlanId}
        />
      ))}
    </motion.div>
  );
};

export default React.memo(MembershipPlansGrid);
